const Grades = {
  sv_SE: [
    { value: 'Kindergarten', label: 'Förskola' },
    { value: 'Preschool', label: 'Förskoleklass' },
    { value: 'Grade 1', label: 'Årskurs 1' },
    { value: 'Grade 2', label: 'Årskurs 2' },
    { value: 'Grade 3', label: 'Årskurs 3' },
    { value: 'Grade 4', label: 'Årskurs 4' },
    { value: 'Grade 5', label: 'Årskurs 5' },
    { value: 'Grade 6', label: 'Årskurs 6' },
    { value: 'Daycare', label: 'Fritidshem/annat' },
  ],
  dk: [
    { value: "Nursery", label: "Vuggestue" },
    { value: 'Preschool', label: 'Børnehaveklasse' },
    { value: 'Grade 1', label: '1. klasse' },
    { value: 'Grade 2', label: '2. klasse' },
    { value: 'Grade 3', label: '3. klasse' },
    { value: 'Grade 4', label: '4. klasse' },
    { value: 'Grade 5', label: '5. klasse' },
    { value: 'Grade 6', label: '6. klasse' },
    { value: 'Daycare', label: 'Fritidshjem/andet' },
  ],
  fi: [
    { value: 'Grade 1', label: '1. luokka' },
    { value: 'Grade 2', label: '2. luokka' },
    { value: 'Grade 3', label: '3. luokka' },
    { value: 'Grade 4', label: '4. luokka' },
    { value: 'Grade 5', label: '5. luokka' },
    { value: 'Grade 6', label: '6. luokka' },
    { value: 'Daycare', label: 'Iltapäiväkerho/muu ryhmä' },
  ],
};

export default Grades;
